import { addMessages } from '@hana/i18n';

// Khoá chuỗi của bản đồ rotation (ServiceMap.tsx). Mã cảng không dịch.
addMessages('vi', {
  'sm.aria': 'Bản đồ rotation {code} · {n} cảng',
  'sm.vnPort': 'Cảng VN',
  'sm.viewRot': 'xem dòng rotation',
  'sm.noCoord': 'Chưa có toạ độ cảng cho rotation này',
  'sm.loop': 'Vòng',
  'sm.days': '{n} ngày',
  'sm.fleet': 'Bố trí',
  'sm.ships': '{n} tàu',
  'sm.freq': 'Tần suất',
  'sm.weekly': 'Hằng tuần',
  'sm.outbound': 'Chiều xuất',
});
addMessages('en', {
  'sm.aria': 'Rotation map {code} · {n} ports',
  'sm.vnPort': 'VN port',
  'sm.viewRot': 'view rotation row',
  'sm.noCoord': 'No port coordinates for this rotation',
  'sm.loop': 'Loop',
  'sm.days': '{n} days',
  'sm.fleet': 'Fleet',
  'sm.ships': '{n} ships',
  'sm.freq': 'Frequency',
  'sm.weekly': 'Weekly',
  'sm.outbound': 'Outbound',
});
